import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "flex flex-row items-center justify-between mt-3 px-6",
  style: {"border-bottom":"1px solid rgba(224, 224, 224, 1)","padding-bottom":"15px"}
}
const _hoisted_2 = { class: "text-xl text-black-lp-200 font-bold" }
const _hoisted_3 = { class: "flex flex-row items-center gap-3" }
const _hoisted_4 = { class: "flex flex-grow bg-gray-lp-1000" }
const _hoisted_5 = { class: "flex flex-row justify-center items-center gap-x-4 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_DownloadLaporan = _resolveComponent("DownloadLaporan")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_PusatResolusiV2TabTicket = _resolveComponent("PusatResolusiV2TabTicket")!
  const _component_ModalCheckIssue = _resolveComponent("ModalCheckIssue")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_PopupIssueInformation = _resolveComponent("PopupIssueInformation")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isInternal)
      ? (_openBlock(), _createBlock(_component_Breadcrumb, {
          key: 0,
          class: "pt-4 px-8 pusat-resolusi-v2-detail"
        }))
      : _createCommentVNode("", true),
    _createVNode("section", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('breadcrumb.pusatResolusi')), 1),
      _createVNode("div", _hoisted_3, [
        (_ctx.showDownloadLaporan)
          ? (_openBlock(), _createBlock(_component_DownloadLaporan, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.showCekKendalaButton || _ctx.isInternal)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 1,
              id: "check-ticket-button",
              title: _ctx.$t('pusatResolusi.cekKendala'),
              outline: "",
              fontWeight: "semibold",
              textColor: "red-lp-200",
              iconV2: "",
              iconLeft: "check-circle-outline",
              iconColor: "red-lp-200",
              onClick: _ctx.onClickCheckIssueButton
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.showBuatKendalaButton)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 2,
              id: "create-ticket-button",
              title: _ctx.$t('pusatResolusi.laporkanKendala'),
              textColor: "white",
              fontWeight: "semibold",
              iconLeft: "plus-circle-white",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toCreate()))
            }, null, 8, ["title"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("section", _hoisted_4, [
      _createVNode(_component_PusatResolusiV2TabTicket)
    ]),
    _createVNode(_component_ModalCheckIssue, {
      modelValue: _ctx.showModalCheckIssue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalCheckIssue = $event)),
      onOnCheckIssue: _ctx.onReportIssue,
      onTicketSelect: _ctx.handleTicketSelect,
      tickets: _ctx.ticketListData
    }, null, 8, ["modelValue", "onOnCheckIssue", "onTicketSelect", "tickets"]),
    (_ctx.showPopupReportIssue)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          id: "modal_stt_belum_pernah_dilaporkan",
          title: _ctx.$t('pusatResolusi.sttNumberNeverReported'),
          message: _ctx.$t('pusatResolusi.sttNumberMessage'),
          image: "Ill_badge_input_manifest_gagal",
          class: "px-8",
          customWidth: "417px"
        }, {
          "custom-button": _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_lp_button, {
                title: _ctx.$t('pusatResolusi.review.cancel'),
                textColor: "red-lp-100",
                color: "red-lp-100",
                outline: "",
                class: "w-1/2",
                customClass: "w-full",
                onClick: _ctx.onCloseReportIssue
              }, null, 8, ["title", "onClick"]),
              _createVNode(_component_lp_button, {
                id: "btn_form_modal_cek_kendala",
                title: _ctx.$t('pusatResolusi.laporkanKendala'),
                textColor: "white",
                color: "red-lp-100",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toCreate(_ctx.refNo))),
                class: "w-1/2",
                customClass: "w-full"
              }, null, 8, ["title"])
            ])
          ]),
          _: 1
        }, 8, ["title", "message"]))
      : _createCommentVNode("", true),
    (_ctx.showPopupInformationIssue)
      ? (_openBlock(), _createBlock(_component_PopupIssueInformation, {
          key: 2,
          modelValue: _ctx.ticketIssue,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.ticketIssue = $event)),
          onClose: _ctx.onClosePopupInformationIssue
        }, null, 8, ["modelValue", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isError)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 3,
          errorType: _ctx.errorCause,
          onCancel: _ctx.closeModalError,
          onTryAgain: _ctx.onCheck,
          modal: ""
        }, null, 8, ["errorType", "onCancel", "onTryAgain"]))
      : _createCommentVNode("", true),
    (_ctx.showWidgetDownload)
      ? (_openBlock(), _createBlock(_component_WidgetDownload, {
          key: 4,
          id: "button_toggle_widget_download_pusat_resolusi",
          customTitle: "Download data"
        }))
      : _createCommentVNode("", true)
  ], 64))
}